import { useState, useRef, useEffect } from 'react';
import useApi from "./useApi";

function useSolution () {
    const [solutionList, setSolutionList] = useState(null);
    const [solution, setSolution] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const solutionListApi = useApi('solution/GetSolutionsByUser');
    const assignedSolutionListApi = useApi('solution/GetSolutionsWorkingInByUser');
    const solutionDeployApi = useApi('solution/DeployBuildeESC');
    const solutionContractCreateApi = useApi('');
    const solutionSetContractorApi = useApi('solution/SetContractorInSolution');
    const solutionContractorAssignApi = useApi('');
    const solutionApi = useApi('');
    const solutionCreateApi = useApi('solution');
    const componentLoad = useRef(true);
    const componentLoadAssigned = useRef(true);
    const componentCreate = useRef(true);
    const componentDeploy = useRef(true);
    const componentContractCreate = useRef(true);
    const componentContractorAssign = useRef(true);
    const componentSetContractor = useRef(true);
    const componentApi = useRef(true);

    useEffect(() => {
        if (componentLoad.current) {
            componentLoad.current = false;
            return;
        }

        setSolutionList(solutionListApi.data);
        setLoading(solutionListApi.loading);
        setError(solutionListApi.error);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [solutionListApi.loading, solutionListApi.error, solutionListApi.data]);

    useEffect(() => {
        if (componentLoadAssigned.current) {
            componentLoadAssigned.current = false;
            return;
        }

        setSolutionList(assignedSolutionListApi.data);
        setLoading(assignedSolutionListApi.loading);
        setError(assignedSolutionListApi.error);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [assignedSolutionListApi.loading, assignedSolutionListApi.error, assignedSolutionListApi.data]);

    useEffect(() => {
        if (componentCreate.current) {
            componentCreate.current = false;
            return;
        }

        setSolution(solutionCreateApi.data);
        setLoading(solutionCreateApi.loading);
        setError(solutionCreateApi.error);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [solutionCreateApi.loading, solutionCreateApi.error, solutionCreateApi.data]);

    useEffect(() => {
        if (componentDeploy.current) {
            componentDeploy.current = false;
            return;
        }

        setSolution(solutionDeployApi.data);
        setLoading(solutionDeployApi.loading);
        setError(solutionDeployApi.error);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [solutionDeployApi.loading, solutionDeployApi.error, solutionDeployApi.data]);

    useEffect(() => {
        if (componentContractCreate.current) {
            componentContractCreate.current = false;
            return;
        }

        setSolution(solutionContractCreateApi.data);
        setLoading(solutionContractCreateApi.loading);
        setError(solutionContractCreateApi.error);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [solutionContractCreateApi.loading, solutionContractCreateApi.error, solutionContractCreateApi.data]);

    useEffect(() => {
        if (componentSetContractor.current) {
            componentSetContractor.current = false;
            return;
        }

        setSolution(solutionSetContractorApi.data);
        setLoading(solutionSetContractorApi.loading);
        setError(solutionSetContractorApi.error);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [solutionSetContractorApi.loading, solutionSetContractorApi.error, solutionSetContractorApi.data]);

    useEffect(() => {
        if (componentContractorAssign.current) {
            componentContractorAssign.current = false;
            return;
        }

        setSolution(solutionContractorAssignApi.data);
        setLoading(solutionContractorAssignApi.loading);
        setError(solutionContractorAssignApi.error);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [solutionContractorAssignApi.loading, solutionContractorAssignApi.error, solutionContractorAssignApi.data]);

    useEffect(() => {
        if (componentApi.current) {
            componentApi.current = false;
            return;
        }

        setSolution(solutionApi.data);
        setLoading(solutionApi.loading);
        setError(solutionApi.error);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [solutionApi.loading, solutionApi.error, solutionApi.data]);

    const getList = async () => {
        solutionListApi.get();
    }

    const getAssignedList = async () => {
        assignedSolutionListApi.get();
    }

    const create = async (data) => {
        solutionCreateApi.jsonPost(data);
    }

    const createEscrowSmartContract = async (solutionId) => {
        const url = `solution/${solutionId}/contract`;
        solutionContractCreateApi.setUrl(url);
        solutionContractCreateApi.jsonPost('');
    }

    const setContractor = async (solutionId, userId) => {
        let data = {
            SolutionId: solutionId,
            UserId: userId
        }

        solutionSetContractorApi.jsonPost(data);
    }

    const deployBuildeESC = async (solutionId) => {
        const url = `solution/${solutionId}/contract/deploy`;
        solutionDeployApi.setUrl(url);
        solutionDeployApi.jsonPost('');
    }

    const confirmContractorAssignment = async (solutionId) => {
        if (!solutionId) {
            throw new Error();
        }

        const url = `solution/${solutionId}/ConfirmContractorAssignment`
        solutionContractorAssignApi.setUrl(url);
        solutionContractorAssignApi.post('');
    }

    const declineContractorAssignment = async (solutionId, comments) => {
        if (!solutionId) {
            throw new Error();
        }

        const url = `solution/${solutionId}/DeclineContractorAssignment`
        solutionContractorAssignApi.setUrl(url);

        const data = {
            comment: comments,
        };

        solutionContractorAssignApi.jsonPost(data);
    }

    const confirmWorkCompletion = async (solutionId) => {
        const url = `solution/${solutionId}/ConfirmWorkCompletion`
        solutionApi.setUrl(url);

        await solutionApi.jsonPost({});
        setSolution({});
    }

    const getById = async (solutionId) => {
        solutionApi.setUrl(`solution/${solutionId}`);
        await solutionApi.get();
    }

    return {
        solutionList,
        solution,
        loading,
        error,
        getList,
        getById,
        getAssignedList,
        create,
        setContractor,
        deployBuildeESC,
        createEscrowSmartContract,
        confirmContractorAssignment,
        declineContractorAssignment,
        confirmWorkCompletion
    };
}

export default useSolution;